<div class="p-d-flex p-dir-col log-in-layout">
  <app-header [isAtLogin]="isAtLogin"></app-header>
  <main class="log-in-bg p-d-flex p-flex-column p-jc-center"  [style.background-image]="'url(' + blobUrlBg +  ')'">
    <div class="log-in-area p-d-flex p-flex-row">
      <div class="log-in-desc p-flex-column p-ai-center"  [style.background-image]="'url(' + blobUrlLogin + ')'">
        <!-- <p>Reset Account Password</p> -->
        <img src="./assets/images/header-logo-holding.svg" alt="" />
        <!-- <article>
          {{ "Login.Description" | translate }}
        </article> -->
      </div>
      <div class="log-in-input forget-in-input">
        <form class="log-in-form" #resetPasswordForm="ngForm">
          <div class="log-in-ele-container log-in-title">
            <p>
              {{
                (isChangeMode ? "Login.ChangePassword" : "ForgotPassword.Title")
                  | translate
              }}
            </p>
          </div>
          <ng-container *ngIf="isChangeMode">
            <!-- Current Password -->
            <div class="log-in-ele-container p-d-flex p-flex-column">
              <label for="password">{{
                "ForgotPassword.CurrentPassword" | translate
              }}</label>
              <div
                class="p-d-flex p-flex-row p-ai-center log-in-input-container"
              >
                <img
                  class="log-in-icon"
                  src="./assets/images/ic-password.svg"
                  width="24px"
                  height="24px"
                />
                <input
                  id="currentPassword"
                  name="currentPassword"
                  type="password"
                  class="login-input-pw"
                  autocomplete="off"
                  [placeholder]="'ForgotPassword.CurrentPassword' | translate"
                  pInputText
                  [(ngModel)]="resetPasswordFormModel.currentPassword"
                  required
                  #currentPasswordDom="ngModel"
                />
              </div>
              <small
                class="p-error"
                *ngIf="
                  currentPasswordDom.invalid &&
                  (currentPasswordDom.dirty || currentPasswordDom.touched) &&
                  currentPasswordDom.errors?.required
                "
              >
                {{ "Common.Validate.MustNotBeBlank" | translate }}
              </small>
            </div>
          </ng-container>

          <!-- New Password -->
          <div class="log-in-ele-container p-d-flex p-flex-column">
            <label for="newPassword">{{
              "ForgotPassword.NewPassword" | translate
            }}</label>
            <div class="p-d-flex p-flex-row p-ai-center log-in-input-container">
              <img
                class="log-in-icon"
                src="./assets/images/ic-password.svg"
                width="24px"
                height="24px"
              />
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                class="login-input-pw"
                autocomplete="off"
                [placeholder]="'ForgotPassword.NewPassword' | translate"
                pInputText
                [(ngModel)]="resetPasswordFormModel.newPassword"
                required
                minlength="8"
                maxlength="256"
                appPasswordComplexity
                #passwordDom="ngModel"
                (input)="newPasswordChange()"
              />
            </div>
            <ng-container
              *ngIf="
                passwordDom.invalid &&
                (passwordDom.dirty || passwordDom.touched)
              "
            >
              <small class="p-error" *ngIf="passwordDom.errors?.required">
                {{ "Common.Validate.MustNotBeBlank" | translate }}
              </small>
              <small
                class="p-error"
                *ngIf="passwordDom.errors?.passwordComplixity"
              >
                {{ "Common.Validate.PasswordStrengNotification" | translate }}
              </small>
            </ng-container>
          </div>
          <!-- Confirm Password -->
          <div class="log-in-ele-container p-d-flex p-flex-column">
            <label for="confirmNewPassword">{{
              "ForgotPassword.ConfirmNewPassword" | translate
            }}</label>
            <div class="p-d-flex p-flex-row p-ai-center log-in-input-container">
              <img
                class="log-in-icon"
                src="./assets/images/ic-password.svg"
                width="24px"
                height="24px"
              />
              <input
                id="confirmNewPassword"
                name="confirmNewPassword"
                type="password"
                class="login-input-pw"
                autocomplete="off"
                [placeholder]="'ForgotPassword.ConfirmNewPassword' | translate"
                pInputText
                [(ngModel)]="resetPasswordFormModel.confirmPassword"
                required
                [appEqualTo]="resetPasswordFormModel.newPassword"
                #confirmPasswordDom="ngModel"
              />
            </div>
            <ng-container
              *ngIf="
                resetPasswordFormModel.newPassword &&
                confirmPasswordDom.invalid &&
                (confirmPasswordDom.dirty || confirmPasswordDom.touched)
              "
            >
              <small
                class="p-error"
                *ngIf="
                  confirmPasswordDom.errors?.required &&
                  !confirmPasswordDom.errors?.equalTo
                "
              >
                {{ "Common.Validate.MustNotBeBlank" | translate }}
              </small>
              <small class="p-error" *ngIf="confirmPasswordDom.errors?.equalTo">
                {{
                  "Common.Validate.ConfirmPasswordNotEqualToPassword"
                    | translate
                }}
              </small>
            </ng-container>
          </div>
          <div *ngIf="elementControlJSON.Login.GoogleReCaptcha.display" class="log-in-ele-container p-d-flex p-flex-column">
            <re-captcha
              name="captcha"
              class="p-d-flex p-jc-center"
              (error)="errored($event)"
              errorMode="handled"
              [(ngModel)]="resetPasswordFormModel.recaptchaToken"
              required
              [siteKey]="appConfig.recaptchaSiteKey"
            ></re-captcha>
          </div>
          <div class="log-in-ele-container p-d-flex">
            <div class="p-col-6">
              <div class="button">
                <a role="button" class="btn btn-clear" (click)="clear()">
                  {{ "Common.Button.Clear" | translate }}</a
                >
              </div>
            </div>
            <div class="p-col-6">
              <div class="button">
                <a
                  role="button"
                  class="btn btn-login"
                  [class.disable]="!resetPasswordForm.valid"
                  (click)="submit()"
                  >{{ "Common.Button.Submit" | translate }}</a
                >
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>

<p-toast position="top-right"></p-toast>
